import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TSignatureValidateDocumentResponse } from '~/store/types.ts';
import { TPersonalDataApplicationRequest } from '~/store/processing-personal/types.ts';

export const validateDocumentProcessingPersonal = createAsyncThunk<
  TSignatureValidateDocumentResponse,
  TPersonalDataApplicationRequest
>(
  'processingPersonal/validateDocumentProcessingPersonalSubmit',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(
        `/personal-data/public/personal-data/applications/${applicationId}/signature-protocols`,
        null
      );
      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeValidateDocumentProcessingPersonal = createAsyncThunk<
  TSignatureValidateDocumentResponse,
  TPersonalDataApplicationRequest
>(
  'processingPersonal/validateDocumentProcessingPersonalRevoke',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/signature-protocols`,
        null
      );
      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
